export const manifestLocales = {
  pdfDocument: {
    previewImageAlt: {
      en: 'PDF document',
      he: 'מסמך PDF'
    }
  }
};
